import { CategorySetPageFragment } from '../../queries/getCategorySetPageAtBuildTime';
import { BusinessLineRoutes } from '../../utils/routingHelper';
import { ModuleCategoryCard } from '../CategoryCardsModule/types';
import { formatCategoryCards } from '../CategoryCardsModule/utils';
import SharedAlphaSortGrid from '../AlphaSortGrid';
interface Props {
  businessLine: BusinessLineRoutes;
  categorySetPage: CategorySetPageFragment;
}
const AlphaSortGrid = ({
  businessLine,
  categorySetPage
}: Props) => {
  const cardsBySectionTitle: Map<string, ModuleCategoryCard[]> = categorySetPage?.categorySet?.cards.reduce((acc, card) => {
    const {
      sectionTitle
    } = card;
    if (!sectionTitle) return acc;

    // Default new sections to empty array
    if (!acc.has(sectionTitle)) {
      acc.set(sectionTitle, []);
    }

    // Add the formatted card to the section
    acc.get(sectionTitle)?.push(formatCategoryCards({
      ...card,
      href: `/${businessLine}/clothing/${categorySetPage.categorySet.id}/${card.category.id}/`
    }));
    return acc;
  }, new Map()) || new Map();
  return <SharedAlphaSortGrid groups={Array.from(cardsBySectionTitle)} linkName="category_card" />;
};
export default AlphaSortGrid;